<template>
    <div class="ResourcesItem">
        <WText
            v-if="type"
            tag="label"
            typo="label"
            weight="semi"
            color="accent-blue"
            size="14"
            uppercase
            class="Title"
        >
            {{ $t(`imports.detail.resources.${type}`), }}
        </WText>

        <DataGrid
            ref="dataGrid"
            class="DataGrid"
            v-bind="dataGridConfig"
            :columns="columns"
            :selectGroups="selectGroups"
            :rows="rows"
            :loading="loading"
            #top="{ grid }"
            @onCellChanged="handleCellChanged"
        >
            <ViewsGrid
                v-if="grid"
                :grid="grid"
                :entityKey="entityKey"
                :type="type"
                :value="active"
                :visible="views"
                dropdownDirection="bottomRight"
                @onLoad="handleLoadView"
            />
        </DataGrid>

        <ModalRequest
            :opened="modal === modals.EDIT_SELECTION"
            :title="$t('entities.actionsModals.editSelection.text')"
            :cancelText="$t('actions.cancel')"
            :okText="$t('actions.confirm')"
            :loading="isLoading"
            preventDefault
            @close="handleCancelEdition"
            @onAccept="editSelected"
        />
    </div>
</template>
<script>
import {
    Api, apiRequest, notifySuccess, rethrowError, notifyHttpError,
} from '@/api'
import VueTypes from 'vue-types'
import { DataGrid, ViewsGrid, ModalRequest } from '@/components'
import GridEntity from '@/entities/grid'

const DATAGRID_CONFIG = {
    hasInputFilter: false,
    cleanFiltersButton: false,
    editable: false,
    rowSelection: 'single',
}

export const MODAL_TYPES = {
    EDIT_SELECTION: 'EDIT_SELECTION',
}

export default {
    name: 'ResourcesItem',
    components: {
        DataGrid,
        ViewsGrid,
        ModalRequest,
    },
    props: {
        rows: VueTypes.array,
        columns: VueTypes.array,
        selectGroups: VueTypes.any,
        entityKey: VueTypes.string,
        type: VueTypes.string,
        detailKey: VueTypes.string,
        views: VueTypes.bool.def(false),
        editable: VueTypes.bool.def(false),
        loading: VueTypes.bool.def(false),
    },
    data () {
        return {
            dataGridConfig: {
                ...DATAGRID_CONFIG,
                filterable: this.editable,
                sideBar: this.editable,
                editable: this.editable,
                defaultColDef: {
                    checkboxSelection: this.isFirstCol,
                },
                contextMenu: this.contextMenu,
            },
            active: undefined,

            editionData: undefined,
            isEditing: false,
            isLoading: false,

            modal: undefined,
            modals: MODAL_TYPES,
        }
    },
    methods: {
        contextMenu ({ node, api }) {
            const renderIcon = icon => `<i class="WIcon icon-${icon} ag-icon" />`

            return [
                'copy',
                'separator',
                ...([
                    {
                        name: this.$t('entities.actions.viewDetail'),
                        action: () => this.$router.push({ name: 'AdminEntityItemDetail', params: { entityKey: this.detailKey, id: node.data.id } }),
                        icon: renderIcon('eye'),
                    },
                ]),
                'separator',
                {
                    name: this.$t('entities.actions.export'),
                    action: () => api.exportDataAsCsv({ columnSeparator: '\t' }),
                    icon: renderIcon('download'),
                },
            ]
        },
        handleLoadView (views) {
            const [, first] = views
            if (first) this.active = first.id
        },
        handleCellChanged ({
            node, colDef, data, oldValue, newValue,
        }) {
            if (GridEntity.compareValues(newValue, oldValue, colDef.type) && !this.isEditing) {
                this.editionData = {
                    fieldKey: colDef.field, rowKey: data.id, oldValue, newValue,
                }
                this.node = node
                this.modal = this.modals.EDIT_SELECTION
                this.isEditing = true
            } else {
                this.isEditing = false // End of field edit
            }
        },
        handleCancelEdition () {
            this.node.setDataValue(this.editionData.fieldKey, this.editionData.oldValue)
            this.handleCleanModal()
        },
        handleCleanModal () {
            this.modal = undefined
            this.node = undefined
            this.editionData = undefined
        },
        async editSelected () {
            const { rowKey: id, fieldKey, newValue: value } = this.editionData
            const params = {
                type: this.type,
                row: { id, [fieldKey]: value },
            }
            const options = { timeout: 0 }
            this.isLoading = true
            apiRequest(Api().imports.create(params, options))
                .then(() => {
                    notifySuccess(this.$t('entities.modals.editSuccess'))()
                    this.handleCleanModal()
                    this.isLoading = false
                    this.isEditing = false
                })
                .catch((error) => {
                    this.handleCancelEdition()
                    rethrowError(notifyHttpError())(error)
                })
        },
    },
}
</script>
<style lang="scss" scoped>
.DataGrid {
    height: 350px;
}

.WText.Title {
    display: block;
    margin-bottom: 15px !important;
    padding: 5px;
    background: $gray-06;
    border-radius: $border-radius;
}
</style>
